


const config = {
    base_url :"https://khetbazaar-backend01.vercel.app/api/v1",
    // base_url: "http://localhost:4000/api/v1",
    default_map_location: `https://www.google.com/maps?q=Bihar purnia, Dhamdaha, Thari rajo`,
    phone: 8452912071,
    email:'support@khetbazaar.in',
    image_mimeType:['image/png', 'image/jpeg'],
    tiler_api_key: "fShEkdTRyweasFOdb50I"
}


export const COMMON_CONSTANTS = { config }